export const REMOVAL_NOTICE_DAYS = 15;

const DAY_MS = 24 * 60 * 60 * 1000;

const startOfLocalDay = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate());

const fromDateInput = (dateInput: string): Date => {
  const [year, month, day] = dateInput.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const toDateInput = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const defaultLastDayOnList = (today: Date, schemeLastDay?: string | null): string => {
  const withFullNotice = toDateInput(
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + REMOVAL_NOTICE_DAYS),
  );
  return schemeLastDay && schemeLastDay < withFullNotice ? schemeLastDay : withFullNotice;
};

export const schemeLastDayOnList = (schemeValidTo: string | null | undefined): string | null =>
  schemeValidTo ? toDateInput(new Date(schemeValidTo)) : null;

export const daysOfNotice = (today: Date, lastDayOnList: string): number =>
  Math.round((fromDateInput(lastDayOnList).getTime() - startOfLocalDay(today).getTime()) / DAY_MS);

export const removalTakesEffectAt = (lastDayOnList: string): string => {
  const lastDay = fromDateInput(lastDayOnList);
  return new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate() + 1).toISOString();
};

export const lastDayOnListBefore = (takesEffectAt: string): Date => new Date(Date.parse(takesEffectAt) - 1);
